export default __webpack_public_path__ + "static/media/iconDownloadCard.80399eb6.svg";